/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_Place_MixInputs */

const en_us2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mix`)
};

const pt_br2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um misto`)
};

const es_419_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mezcla`)
};

const pt_pt2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um misto`)
};

const fr_fr2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mélange`)
};

const de_de2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemischt`)
};

const it_it2_onboarding_equipment_place_mix = /** @type {(inputs: Onboarding_Equipment_Place_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mix`)
};

/**
* | output |
* | --- |
* | "A mix" |
*
* @param {Onboarding_Equipment_Place_MixInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_place_mix = /** @type {((inputs?: Onboarding_Equipment_Place_MixInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_Place_MixInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_place_mix(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_place_mix(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_place_mix(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_place_mix(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_place_mix(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_place_mix(inputs)
	return en_us2_onboarding_equipment_place_mix(inputs)
});
export { onboarding_equipment_place_mix as "onboarding.equipment_place.mix" }